import clsx from 'clsx'
import { IDropdownSubtitleProps } from './types'
import styles from './styles.module.scss'

const DropdownSubtitle = ({ size = 'md', subtitle }: IDropdownSubtitleProps) => {
  return <p className={clsx('mui-dropdown-subtitle', styles[`subtitle${size}`])}>{subtitle}</p>
}

export default DropdownSubtitle
